export default __webpack_public_path__ + "static/media/trendFall.dd42d827.svg";